import { AnimatedSection } from "@/components/common/AnimatedSection"
import { SectionLabel } from "@/components/common/SectionLabel"
import { LEGAL_LINKS } from "@/data/legal"
import { useSEO } from "@/hooks/useSEO"
import { createFileRoute, Link } from "@tanstack/react-router"

export const Route = createFileRoute("/legal")({
  component: LegalHomePage,
})

function LegalHomePage() {
  useSEO({
    title: "Legal",
    description: "Legal documents and policies for Orchestrate.",
  })

  return (
    <>
      {/* Hero Section */}
      <section className="bg-surface grid-bg relative overflow-hidden pt-32 pb-20">
        <div className="hero-glow" aria-hidden="true" />
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="grid items-start gap-0 lg:grid-cols-2">
            <div className="max-w-4xl text-left">
              <AnimatedSection>
                <SectionLabel label="Legal Center" className="mb-5" />
              </AnimatedSection>
            </div>
            <div className="max-w-2xl text-left">
              <AnimatedSection delay={0.3}>
                <nav className="space-y-6">
                  {LEGAL_LINKS.map((link) => (
                    <Link
                      key={link.href}
                      to={link.href}
                      className="text-ink hover:text-blue block py-2 text-lg font-medium transition-colors duration-150"
                    >
                      {link.label}
                    </Link>
                  ))}
                </nav>
              </AnimatedSection>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
